var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgSanitaryIcon = function SvgSanitaryIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7144 4.42773L4.42871 26.7134",
    stroke: "#8293A4",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.424 9.51609L20.9319 22.3095C20.9169 22.6999 20.5823 23.0215 20.1912 23.0215H11.6633C11.2716 23.0215 10.9377 22.7002 10.9226 22.3095L10.4306 9.51609C10.4228 9.31383 10.2525 9.15617 10.0503 9.16395C9.84801 9.17173 9.69035 9.342 9.69813 9.54426L10.1902 22.3377C10.2204 23.1221 10.8779 23.7545 11.6633 23.7545H20.1912C20.9757 23.7545 21.6342 23.122 21.6644 22.3377L22.1564 9.54426C22.1642 9.342 22.0065 9.17173 21.8043 9.16395C21.602 9.15617 21.4318 9.31383 21.424 9.51609Z",
    fill: "#8293A4",
    stroke: "#8293A4",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5602 12.1942V21.2551C15.5602 21.4575 15.7242 21.6216 15.9267 21.6216C16.1291 21.6216 16.2931 21.4575 16.2931 21.2551V12.1942C16.2931 11.9918 16.1291 11.8277 15.9267 11.8277C15.7242 11.8277 15.5602 11.9918 15.5602 12.1942Z",
    fill: "#8293A4",
    stroke: "#8293A4",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6287 12.205L12.8952 21.2659C12.9011 21.4682 13.07 21.6274 13.2723 21.6215C13.4746 21.6155 13.6338 21.4467 13.6278 21.2443L13.3614 12.1835C13.3554 11.9811 13.1866 11.8219 12.9842 11.8279C12.7819 11.8338 12.6227 12.0027 12.6287 12.205Z",
    fill: "#8293A4",
    stroke: "#8293A4",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4919 12.1835L18.2254 21.2443C18.2194 21.4467 18.3786 21.6155 18.5809 21.6215C18.7832 21.6274 18.9521 21.4682 18.958 21.2659L19.2245 12.205C19.2305 12.0027 19.0713 11.8338 18.869 11.8279C18.6666 11.8219 18.4978 11.9811 18.4919 12.1835Z",
    fill: "#8293A4",
    stroke: "#8293A4",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26454 9.89666H22.5894C22.7918 9.89666 22.9559 9.73258 22.9559 9.53017C22.9559 9.32776 22.7918 9.16367 22.5894 9.16367H9.26454C9.06213 9.16367 8.89805 9.32776 8.89805 9.53017C8.89805 9.73258 9.06213 9.89666 9.26454 9.89666Z",
    fill: "#8293A4",
    stroke: "#8293A4",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4724 9.72244L13.5652 9.75958L13.6024 9.66673L13.8876 8.95368C13.9263 8.85686 14.0127 8.75827 14.1234 8.68321C14.2342 8.60815 14.3576 8.56463 14.4613 8.56463H17.3928C17.4974 8.56463 17.6207 8.60795 17.731 8.68272C17.8413 8.75748 17.9275 8.85603 17.9665 8.95368L18.2517 9.66673L18.2889 9.75958L18.3817 9.72244L18.8766 9.52449L18.9694 9.48735L18.9323 9.39451L18.6471 8.68145C18.4543 8.19944 17.9111 7.83164 17.3928 7.83164H14.4613C13.9445 7.83164 13.3993 8.20073 13.207 8.68145L12.9218 9.39451L12.8847 9.48735L12.9775 9.52449L13.4724 9.72244Z",
    fill: "#8293A4",
    stroke: "#8293A4",
    strokeWidth: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.45,
    stroke: "#8293A4",
    strokeWidth: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.95,
    stroke: "#8293A4",
    strokeWidth: 0.9
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSanitaryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sanitary_icon.ee84a209.svg";
export { ForwardRef as ReactComponent };